export default __webpack_public_path__ + "static/media/avatar-profile.5b811c8d.svg";